export default {"src":"/_next/static/media/default_user.05ab54ad.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};